import { itx } from "../../translationItx/itx";
import Cabinet from "../../models/Cabinet";
import ELCB from "../../models/ELCB";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addActorElcbTerminalStrip from "./guideSequence_addActorElcbTerminalStrip";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstELCB: ELCB | undefined = state.cabinets.sortBy("tag")[0]?.elcbs.sortBy("tag")[0];
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (!firstELCB) {
          return [...guideSequence_addActorElcbTerminalStrip("ELCB")]; // no itx
        } else {
          return [];
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        firstELCB = state.cabinets.sortBy("tag")[0]?.elcbs.sortBy("tag")[0];
        state.selectionManager.selectedObject = firstELCB;
      },
    },

    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        let firstCabinet = state.cabinets.sortBy("tag")[0];
        if (!firstCabinet) {
          firstCabinet = new Cabinet(
            { tag: "01", name: itx("listComponents.newCabinet", "Neuer Schaltschrank") },
            state.cabinets,
          );
        }
        firstELCB = firstCabinet.elcbs.sortBy("tag")[0];
        if (!firstELCB) {
          firstELCB = new ELCB({ tag: "01", name: itx("listComponents.newELCB", "Neue FI") }, firstCabinet.elcbs);
        }
        state.selectionManager.selectedObject = firstELCB;
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${firstELCB?.id}`;
      },
    },
    {
      action: enumActions.click,
      id: () => {
        return [`tv-${firstELCB?.id}`, `ContextMenuLables_addFuse`];
      },
    },
    // {
    //   action: enumActions.explain,
    //   text: "Eine neue Sicherung wurd in der fi T1 erstellt".replace("T1", firstELCB?.fullname || ""),
    //   id: () => {
    //     return [`${state.selectionManager.selectedObject?.id}`];
    //   },
    // },
  ];
}

export default sequence;
